import { createGlobalState } from 'react-global-hooks';
import Roles from '@interfaces/Roles';

const rolesState = createGlobalState(null as null | Roles);

export default rolesState;
